var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "448ABEA8-D110-438C-9699-DC30D67A16A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CRM-With-Starter-Pkg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CRM->-Clients->-Debt-Settlement-Clients->-Detail-Page->-Profile-Tab",
    transform: "translate(-862.000000, -297.000000)",
    fill: "#1C2022"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.528017,297.019631 C871.528017,297.019631 872.395354,296.897727 872.757671,297.261475 C873.119988,297.625223 872.968646,298.465948 872.968646,298.465948 L871.440629,300 L870,298.553682 L871.528017,297.019631 Z M869.549305,299 L871,300.445358 L864.760325,306.662079 L862,308 L863.30963,305.216721 L869.549305,299 Z",
    id: "Shape-Copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1e273a7c3fe08ead8233948bdd78d2c7.svg";
export { ForwardRef as ReactComponent };